import { queries } from './graphql'
import { ContentStates, useContext } from './Context'
import { useMutation, useUser } from '@ztechapps/common.hook'

export const useAddBoard = () => {
  const [addBoard] = useMutation({
    ...queries.createConfig,
    options: { mutationOptions: { refetchQueries: ['singleBoard'] } },
  })
  const { user } = useUser()

  const { onClose, entity, setContentState } = useContext()
  const onSubmit = async (args) => {
    const input = {
      ...args,
      items: [{ entity: { _id: entity?._id } }],
      users: [user?._id],
    }

    await addBoard({ input })

    //just call the reset
    onReset()
  }
  const onReset = () => {
    setContentState(ContentStates.addItem)
    onClose()
  }

  const validate = (values) => {
    const errors: any = {}

    if (!values.name) {
      errors.name = 'Required'
    }

    return errors
  }

  return { onSubmit, onReset, validate }
}
